import React from 'react'
import { Alert, Form, Input, Modal } from 'antd'
import { useDispatch } from 'react-redux'
import { useCreateProblemSetMutation } from '../../../store/apis/problem-sets.api'
import { setEditingProblemSetId, toggleCreateProblemSetModal } from '../../../store/slices/problem-sets.slice'
import { openNotificationWithIcon } from '../../../utils/notification.helper'
import { INSTRUCTIONS_LIMIT } from '../../../constants/input-limits'
import TextArea from 'antd/es/input/TextArea'
import { useAutoFocusFirstInput } from '../../../../hooks/useAutoFocusFirstInput'

const CreateProblemSetModal = () => {
    const dispatch = useDispatch()

    const [createProblemSet, createProblemSetResult] = useCreateProblemSetMutation()

    const [form] = Form.useForm()
    useAutoFocusFirstInput()

    const handleCancelCreateProblemSet = () => dispatch(toggleCreateProblemSetModal())

    const handleCreateProblemSet = async values => {
        const createProblemSetResponse = await createProblemSet({
            name: values.name,
            instructions: values.instructions,
        })
        if (createProblemSetResponse?.data) {
            dispatch(toggleCreateProblemSetModal())
            dispatch(setEditingProblemSetId(createProblemSetResponse.data.id))
            openNotificationWithIcon('success', 'Problem set created successfully')
        }
    }

    return (
        <Modal
            title='Create problem set'
            open={true}
            okButtonProps={{ htmlType: 'submit', form: 'create-problem-set' }}
            okText='Create'
            confirmLoading={createProblemSetResult.isLoading}
            onCancel={handleCancelCreateProblemSet}
        >
            <Form
                name='create-problem-set'
                onFinish={handleCreateProblemSet}
                form={form}
                autoComplete='off'
                layout='vertical'
                requiredMark={false}
                validateTrigger={['onBlur', 'onSubmit']}
            >
                <Form.Item
                    name='name'
                    rules={[{ required: true, message: 'Please, enter name for the new problem set' }]}
                    label='Name'
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label='Instructions'
                    name='instructions'
                    rules={[
                        {
                            type: 'string',
                            max: INSTRUCTIONS_LIMIT,
                        },
                    ]}
                >
                    <TextArea rows={6} />
                </Form.Item>
            </Form>
            {createProblemSetResult.isError && (
                <Alert message={createProblemSetResult?.error} type='error' showIcon closable />
            )}
        </Modal>
    )
}

export default CreateProblemSetModal
